var render = function render(){var _vm=this,_c=_vm._self._c;return _c('button',{class:[
			_vm.type == 'blank' ? '' : '',
			_vm.type == 'primary'
				? 'truncate bg-orange-500 text-white px-4 py-1.5 font-medium rounded-lg focus:ring-2 focus:ring-orange-200 focus:ring-offset-2 focus:ring-offset-gray-50 focus:ring-orange-400 shadow hover:shadow-md hover:bg-orange-600 focus:outline-none font-medium' +
				  (_vm.disabled ? ' opacity-50' : '')
				: '',
			//type == 'primary' ? 'truncate bg-orange-500 text-white px-4 py-1.5 font-medium rounded-lg focus:ring-2 focus:ring-orange-200' : '',
			_vm.type == 'success'
				? 'truncate bg-green-500 text-white px-4 py-1.5 font-medium rounded-lg focus:ring-2 focus:ring-green-200'
				: '',
			_vm.type == 'secondary'
				? 'bg-gray-150 rounded-lg py-1.5 px-4 font-medium text-gray-500 hover:bg-gray-200 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-offset-gray-50 focus:ring-orange-400'
				: '',
			_vm.type == 'primary-reverted'
				? 'truncate bg-white-500 text-orange px-4 py-1.5 font-medium rounded-lg border-orange ring-2 ring-orange-400 focus:ring-2 focus:ring-orange-200 focus:ring-offset-2 focus:ring-offset-gray-50 focus:ring-orange-400 shadow hover:shadow-md hover:bg-orange-600 hover:text-white focus:outline-none font-medium'
				: '',
			_vm.type == 'primary-disabled'
				? 'bg-gray-300 rounded-lg py-1.5 px-4 font-medium text-white focus:outline-none'
				: '',
		],attrs:{"type":_vm.nativeType,"disabled":_vm.disabled},on:{"click":function($event){return _vm.$emit('click')}}},[_vm._t("default",function(){return [_vm._v(_vm._s(_vm.__(_vm.label)))]})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }